import { type ReactNode, useEffect, useRef } from "react";

const emitter = (() => {
	let currentRow = -1;
	let currentCol = -1;
	const subs: ((isHighlighted: boolean) => void)[][] = [];

	return {
		subscribe(r: number, c: number, cb: (isHighlighted: boolean) => void) {
			subs[r] = subs[r] ?? [];
			subs[r][c] = cb;
			return () => delete subs[r][c];
		},
		highlight(newRow: number, newCol: number) {
			subs.forEach((row, r) => {
				row.forEach((cb, c) => {
					const wasHighlighted = r === currentRow || c === currentCol;
					const isHighlighted = r === newRow || c === newCol;
					if (wasHighlighted !== isHighlighted) {
						cb(isHighlighted);
					}
				});
			});
			currentRow = newRow;
			currentCol = newCol;
		},
	};
})();

interface TableCellProps {
	row: number;
	column: number;
	children?: ReactNode;
	className?: string;
	onClick?: () => void;
}

export function TableCell({ row, column, children, className, onClick }: TableCellProps) {
	const ref = useRef<HTMLTableCellElement>(null);

	useEffect(() => {
		emitter.subscribe(row, column, (isHighlighted) => {
			if (ref.current) {
				ref.current.classList.toggle('has-highlight', isHighlighted);
			}
		});

	}, [column, row]);

	return (
		<td
			onMouseEnter={() => emitter.highlight(row, column)}
			onMouseLeave={() => emitter.highlight(-1, -1)}
			className={className}
			onClick={onClick}
			ref={ref}>
			{children}
		</td>
	);
}
